import { render } from "./receiptrecordmodel.vue?vue&type=template&id=5d1f51c9&scoped=true"
import script from "./receiptrecordmodel.vue?vue&type=script&lang=ts"
export * from "./receiptrecordmodel.vue?vue&type=script&lang=ts"

import "./receiptrecordmodel.vue?vue&type=style&index=0&id=5d1f51c9&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5d1f51c9"

export default script